module.exports = __webpack_public_path__ + "static/img/7f29da99de4bf274300a8f1e98a7f74.ce3f53b2.png";